module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dy-item-wrap', {
    attrs: {
      "item": _vm.item
    }
  }, [_c('el-radio-group', _vm._g(_vm._b({
    attrs: {
      "disabled": _vm.item.disabled
    }
  }, 'el-radio-group', _vm.$attrs, false), _vm.$listeners), _vm._l((_vm.item.options), function(o) {
    return _c(_vm.item.button ? 'el-radio-button' : 'el-radio', {
      key: o.value,
      tag: "component",
      attrs: {
        "label": o.value,
        "disabled": o.disabled,
        "border": _vm.item.border
      }
    }, [_vm._v(_vm._s(o.label))])
  }), 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7a71fcbe"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DynamicForm/widgets/RadioWidget.vue
// module id = 722
// module chunks = 20